import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Home = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <header className="bg-white shadow-md">
        <div className="max-w-7xl 4xl:max-w-10xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
          <div className="flex items-center gap-3">
            <h1 className="text-2xl font-bold text-primary-600">Market Mavericks</h1>
            {user && <span className="text-sm text-gray-600">Hi, {user.name}</span>}
          </div>
          <button
            onClick={handleLogout}
            className="bg-danger-500 text-white px-4 py-2 rounded-lg hover:bg-danger-600 transition duration-200"
          >
            Logout
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl 4xl:max-w-10xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Welcome to Your Dashboard</h2>
          <p className="text-gray-600 mb-6">
            This is your home page after login. You can start building your trading dashboard here.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
            <div className="bg-primary-50 p-6 rounded-lg border border-primary-200">
              <h3 className="text-xl font-semibold text-primary-800 mb-2">Portfolio</h3>
              <p className="text-gray-600">View and manage your portfolio</p>
            </div>
            <div className="bg-secondary-50 p-6 rounded-lg border border-secondary-200">
              <h3 className="text-xl font-semibold text-secondary-800 mb-2">Trading</h3>
              <p className="text-gray-600">Start trading and make investments</p>
            </div>
            <div className="bg-primary-100 p-6 rounded-lg border border-primary-300">
              <h3 className="text-xl font-semibold text-primary-800 mb-2">Analytics</h3>
              <p className="text-gray-600">Track your performance and analytics</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Home;

